<template>
  <div class="card-company">
    <n-modal-card :tabs="tabs" name="company" :loading="$var('loading')">
      <template #header>Карточка компании</template>
      <template #body>
        <div>
          <n-divide class="body">
            <n-items class="content">
              <n-image class="avatar" :src="$form.get('avatar')" :mock="!$form.get('avatar')" centered alt="avatar" round />
              <div>
                <div>{{ model.title }}</div>
              </div>
            </n-items>
          </n-divide>

          <n-button v-if="$form.editable()" style="margin-top: 20px; font-size: .8em" color="primary" @click="() => $var('avatar', true)">Редактировать фото</n-button>
        </div>
      </template>
      <template #tab.info>
        <n-items>
          <n-input title="БИН" v-bind="$form.input('bin')" text />
          <n-input title="Название" v-bind="$form.input('title')" />
          <n-input title="Описание" v-bind="$form.input('description')" />
          <n-input title="Контакты" v-bind="$form.input('contacts')" />
        </n-items>
      </template>
      <template #tab.staff>
        <tab-workers :company-id="companyId" :editable="editable" />
      </template>
      <template #tab.admins>
        <tab-admins :editable="editable" />
      </template>
      <template #footer="{tab}">
        <n-divide>
          <n-button @click="() => $router.back()">Закрыть</n-button>
          <n-items v-if="tab.callback" inline>
            <n-button v-if="editable && !$form.editable() && tab.name === 'info'" color="primary" @click="$form.edit()">Редактировать</n-button>
            <n-button v-if="$form.editable()" @click="$form.cancel()">Отмена</n-button>
            <n-button v-if="$form.editable()" color="success" @click="tab.callback">Сохранить</n-button>
          </n-items>
        </n-divide>
      </template>
    </n-modal-card>

    <n-modal v-if="$var('avatar')" class="modal-new-avatar" :loading="$var('loadingSubmitAvatar')" @close="() => $var('avatar', false)">
      <h3>Загрузить аватар</h3>
      <n-form @submit="submitAvatar">
        <n-items>
          <n-upload :value.sync="file" />
          <n-button color="primary" wide type="submit">Сохранить</n-button>
        </n-items>
      </n-form>
    </n-modal>
  </div>
</template>

<script>
import TabWorkers from './Workers'
import TabAdmins from './Admins'

export default {
  name: 'CardCompany',
  components: { TabAdmins, TabWorkers, },
  data() {
    return {
      tabs: [
        { name: 'info', title: 'Информация', callback: this.save, },
        { name: 'staff', title: 'Сотрудники', },
        { name: 'admins', title: 'Администраторы', },
      ],
      model: {},
      editable: false,
      file: null,
    }
  },
  computed: {
    companyId() {
      return this.$route.query.id
    },
  },
  watch: {
    '$route.query.id'() {
      if (this.$route.query.modal === 'company') {
        this.load()
      }
    },
  },
  created() {
    if (this.$route.query.modal === 'company') {
      this.load()
    }
  },
  methods: {
    load() {
      this.$var('loading', true)
      $api.companies.get(this.companyId).then((response) => {
        this.model = response.data.content
        this.$form.init(this.model, false)
        this.$var('loading', false)
      })
      $api.companies.workers.get(this.companyId).filter({ id: $app.auth.user().id, }).then((response) => {
        this.editable = response.data.content[0].worker.isAdmin
      })
    },
    save() {
      if (this.$form.check()) {
        this.$var('loading', true)
        $api.companies.edit(this.companyId, this.$form.get()).then((response) => {
          this.model = response.data.content
          this.$form.init(this.model, false)
          this.$var('loading', false)
          this.$d.reloadTag('companies')
          this.$router.go()
        }).catch(() => {
          this.$var('loading', false)
        })
      }
    },
    submitAvatar() {
      this.$var('loadingSubmitAvatar', true)
      $api.files.create({ file: this.file, }).then((response) => {
        $api.companies.edit(this.companyId, { avatar: response.data.content.id, }).then((response) => {
          this.model = response.data.content
          this.$form.init(this.model, false)
          this.$d.reloadTag('companies')
          this.$var('avatar', false)
        }).finally(() => {
          this.$var('loadingSubmitAvatar', false)
        })
      }).catch(() => {
        this.$var('loadingSubmitAvatar', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.card-company {

}
</style>
